const APPSLIST = {
  TITLE: 'Apps List',
  DESCRIPTION: 'By adding the application, you can easily use the Raychat API.',
  ADD_APP_BUTTON: 'Add Application',
  USER_MANUAL_BUTTON: 'User Guide',
  EMPTY_LIST_TITLE: "You haven't added any applications.",
  EMPTY_LIST_SUB_TITLE: 'Add the first application.',
  ADD_APP_MODAL_TITLE: 'Add Application',
  ADD_APP_MODAL_FIRST_PLACEHOLDER: 'App Title *',
  ADD_APP_MODAL_SECOND_PLACEHOLDER: 'App Description *',
  ADD_APP_MODAL_ERROR_MESSAGE: 'All fields must be filled out!',
  SUCCESS_MODAL_TITLE: 'Your application has been successfully created.',
  SUCCESS_MODAL_SUB_TITLE: 'Adding the first application.',
  SUCCESS_MODAL_BUTTON: 'Go to the list of apps',
  COPY_MESSAGE: 'Click to copy!',
  COPIED: 'Copied!',
  ACTIVE: 'Active',
  NOT_ACTIVE: 'Inactive',
  DELETE_TITLE: 'Delete App',
  DELETE_DESC: 'Are you sure you want to delete this app?',
  DELETE_CONFIRMATION_BTN: 'Yes',
  DELETE_CANCEL_BTN: 'No',
  TITLE_ERROR_MESSAGE: 'Writing program title is mandatory!',
  DESCRIPTION_ERROR_MESSAGE: 'Writing program descriptions is mandatory!',
};

export default APPSLIST;
